import React from "react";
import "./HousekeepingHero.css";
import Navbar from "../../Header/Navbar";
import { Link } from "react-router-dom"; // ← Added routing

const FacadeExternalCleaningHero = () => {
  return (
    <>
      <Navbar />

      {/* HERO SECTION */}
      <section className="hk-hero">
        <div className="hk-container">
          
          {/* Main Title */}
          <h1 className="hk-title">Facade & External Cleaning</h1>

          {/* Breadcrumb with Links */}
          <p className="hk-subtitle">

            <Link to="/" className="hk-breadcrumb-link">Home</Link>
            <span>-</span>

            <Link to="/services" className="hk-breadcrumb-link">Our Services</Link>
            <span>-</span>

            <Link
              to="/corporate-FacadeExternalCleaning"
              className="hk-breadcrumb-link"
            >
              Facade & External Cleaning
            </Link>

          </p>

        </div>
      </section>

      {/* About Tag BELOW HERO */}
      <div className="hk-tag-wrapper">
        <div className="hk-tag">About This Service</div>
      </div>
     
    </>
  );
};

export default FacadeExternalCleaningHero;
